/* eslint-disable array-callback-return */
/* eslint-disable no-unused-expressions */
/* eslint-disable jsx-a11y/label-has-for */
/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable camelcase */
/* eslint-disable react/no-array-index-key */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable react/jsx-no-script-url */
/* eslint-disable no-script-url */
/* eslint-disable no-undef */
/* eslint-disable no-unused-vars */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable max-len */
import React, {
    useState, useCallback, useRef, useEffect,
} from 'react';
import Checkbox from 'react-custom-checkbox';
import moment from 'moment';
import * as Icon from 'react-icons/fi';
import { createUrl } from '../../../redux/helper/CreateQuery';
import { removeLastComma } from '../../../redux/helper/RemoveComma';
import { distributorService } from '../../../service/distributor.service';

function FilterModal({
    close, setFilter, Filter, handleFetch, setfilterUrl, selected, setselected,
}) {
    // const order_Status = {
    //     Draft: 0,
    //     Pending: 1,
    //     InProcess: 2,
    //     'ApprovedOut for delivery': 3,
    //     'Partially delivered': 4,
    //     Deliverd: 5,
    //     Completed: 6,
    //     Cancelled: 7,
    // };
    const order_status = {
        0: 'Draft',
        1: 'Pending',
        2: 'InProcess',
        3: 'Approved',
        4: 'Out for delivery',
        5: 'Partially Delivered',
        6: 'Deliverd',
        7: 'Completed',
        8: 'Rejected',
    };
    const [selectedType, setselectedType] = useState('order_type');
    const getObjectUrl = () => {
        let final = '';
        Filter.order_status.length > 0 && Filter.order_status.map((val) => {
            final += `${val},`;
        });
        return removeLastComma(final);
    };
    const generateUrl = (val) => {
        let final = '';
        Object.keys(Filter).map((key) => {
            switch (key) {
            case 'order_type':
                if (Filter[key].length !== 0) { final += `&order_type=${createUrl(Filter[key])}`; }

                break;
            case 'order_status':
                if (Filter[key].length !== 0) {
                    final += `&status=${getObjectUrl()}`;
                } else {
                    final += '&status=3,4,5,6,7,8';
                }
                break;
            case 'type':
                if (Filter[key].length !== 0) { final += `&type=${createUrl(Filter[key])}`; }
                break;
            case 'order_category':
                if (Filter[key].length !== 0) { final += `&order_category=${createUrl(Filter[key])}`; }
                break;
            default: break;
            }
        });
        handleFetch(final);
        setfilterUrl(final);
        return final;
    };

    const handleClear = () => {
        setFilter({
            order_type: [],
            order_status: [],
            type: [],
            order_category: [],
        });
        setfilterUrl('');
        handleFetch('', 'clear');
    };
    const HandleFilter = useCallback((key, val) => {
        const Filtercopy = { ...Filter };
        const idx = Filtercopy[key].indexOf(val);
        if (idx === -1) {
            Filtercopy[key].push(val);
        } else {
            Filtercopy[key].splice(idx, 1);
        }
        Filtercopy[key];
        setFilter(Filtercopy);
        return idx > -1;
        // return false
    }, []);
    const toggleState = {
        start_date: false,
        end_date: false,
    };
    const currentDate = moment(new Date()).format('YYYY/MM/DD');
    const ref = useRef();
    const ref1 = useRef();
    const [toggle, settoggle] = useState(toggleState);
    const [industry, setIndustry] = useState([]);
    const handleToggle = (key) => {
        settoggle((prevState) => ({
            ...prevState,
            [key]: !toggle[key],
        }));
    };

    const getIndustry = useCallback(
        async () => {
            const Industry = await distributorService.getAllIndusty();
            if (!Industry.error && Industry.data.success_status) {
                setIndustry(Industry.data.data);
            }
        },
        [],
    );
    useEffect(() => {
        getIndustry();
    }, []);

    return (
        <div
            className="modal-content border-none shadow-lg relative flex flex-col w-full pointer-events-auto bg-white bg-clip-padding rounded-md outline-none text-current"
        >
            <div className="modal-header flex flex-shrink-0 items-center justify-between pt-[26px] rounded-t-md">
                <h5 className="text-lg font-semibold text-[#090406] text-center w-full" id="exampleModalScrollableLabel1">
                    Filter
                </h5>
                <img
                    className="p-2 rounded-full cursor-pointer absolute top-4 right-4"
                    src="/images/Component158–2.svg"
                    alt="close-icon"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                    onClick={() => close(false)}
                />
            </div>
            <div className="modal-body relative sm:px-5 px-3 sm:pt-5 pt-4 sm:pb-7 pb-5 text-center">
                <div className="flex items-start">
                    <ul className="nav nav-pills flex active flex-col flex-wrap items-start list-none pl-0 w-[30%] h-full" id="pills-tabVertical" role="tablist">
                        <li className="nav-item flex-grow w-full text-start p-1" role="presentation" onClick={() => setselectedType('order_type')}>
                            <a
                                href="javascript:void(0)"
                                className={`block text-base font-semibold ${selectedType === 'order_type' ? 'nav-link active' : ''} text-[#AAA6AF] order relative w-full`}
                                id="pills-priceranje"
                                data-bs-toggle="pill"
                                data-bs-target="#pills-pricetab"
                                role="tab"
                                aria-controls="pills-price"
                                aria-selected="true"
                                data-testid="order-type"
                            >
                                Order Type
                            </a>
                        </li>
                        <li className="nav-item flex-grow text-start w-full p-1" role="presentation" onClick={() => setselectedType('order_status')}>
                            <a
                                href="javascript:void(0)"
                                className={`block text-base font-semibold ${selectedType === 'order_status' ? 'nav-link active' : ''} text-[#AAA6AF] order relative w-full`}
                                id="pills-categories"
                                data-bs-toggle="pill"
                                data-bs-target="#pillcategorie"
                                role="tab"
                                aria-controls="pillcategorie"
                                aria-selected="false"
                                data-testid="order-status"
                            >
                                Order Status
                            </a>
                        </li>
                        <li className="nav-item flex-grow text-start w-full p-1" role="presentation" onClick={() => setselectedType('type')}>
                            <a
                                href="javascript:void(0)"
                                className={`block text-base font-semibold ${selectedType === 'type' ? 'nav-link active' : ''} text-[#AAA6AF] order relative w-full`}
                                id="pills-categories"
                                data-bs-toggle="pill"
                                data-bs-target="#pillcategorie"
                                role="tab"
                                aria-controls="pillcategorie"
                                aria-selected="false"
                                data-testid="type-order"
                            >
                                Type
                            </a>
                        </li>
                        <li className="nav-item flex-grow text-start w-full p-1" role="presentation" onClick={() => setselectedType('order_category')}>
                            <a
                                href="javascript:void(0)"
                                className={`block text-base font-semibold ${selectedType === 'order_category' ? 'nav-link active' : ''} text-[#AAA6AF] order relative w-full`}
                                id="pills-categories"
                                data-bs-toggle="pill"
                                data-bs-target="#pillcategorie"
                                role="tab"
                                aria-controls="pillcategorie"
                                aria-selected="false"
                                data-testid="order-category"
                            >
                                Order Category
                            </a>
                        </li>
                    </ul>
                    <div className="tab-content w-[70%] h-[450px] border-l border-[#D8D8D8]" id="pills-tabContentVertical">
                        <div className={`tab-pane fade ${selectedType === 'order_type' ? 'show active' : ''} px-3`} id="pills-pricetab" role="tabpanel" aria-labelledby="pills-priceranje">
                            <div className="relative">
                                <div className="cursor-pointer">
                                    {['Trade', 'Trade EUB', 'Domestic', 'Free Service', 'Demo', 'Free Samples', 'Free Replacement', 'Service', 'Repair', 'Free Supplies'].map((orderType, orderInd) => (
                                        <div
                                            key={`order${orderInd}`}
                                            className="relative flex items-center mb-3"
                                            onClick={() => HandleFilter('order_type', orderType)}
                                        >
                                            <Checkbox
                                                icon={
                                                    <Icon.FiCheck color="#FFFF" size={14} style={{ background: `${Filter.order_type?.includes(orderType) ? '#555259' : ''}` }} />
                                                }
                                                name="my-input"
                                                className="cursor-pointer"
                                                checked={Filter.order_type?.includes(orderType)}
                                                borderColor={`${Filter.order_type?.includes(orderType) ? '#B8C5DC' : '#555259'}`}
                                                style={{ cursor: 'pointer' }}
                                                labelStyle={{ marginLeft: 5, userSelect: 'none', cursor: 'pointer' }}
                                            />
                                            <label htmlFor={`order${orderInd}`} data-testid={orderType.toLowerCase().replace(/\s+/g, '-')} className="consumbales pl-3 text-sm font-normal text-[#090406] text-left cursor-pointer">
                                                {orderType}
                                                {' '}
                                                Order
                                            </label>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </div>
                        <div className={`tab-pane fade${selectedType === 'order_status' ? 'show active' : ''} w-full overflow-auto h-[190px] sidebar`} id="pills-sizemm" role="tabpanel" aria-labelledby="pills-size">
                            <div className="ml-5 cursor-pointer">
                                <div
                                    className="relative flex items-center mb-3"
                                    onClick={() => HandleFilter('order_status', '1')}
                                >
                                    <Checkbox
                                        icon={
                                            <Icon.FiCheck color="#FFFF" size={14} style={{ background: `${Filter.order_status?.includes('1') ? '#555259' : ''}` }} />
                                        }
                                        name="my-input"
                                        className="cursor-pointer"
                                        checked={Filter.order_status.includes('1')}
                                        borderColor={`${Filter.order_status.includes('1') ? '#B8C5DC' : '#555259'}`}
                                        style={{ cursor: 'pointer' }}
                                        labelStyle={{ marginLeft: 5, userSelect: 'none', cursor: 'pointer' }}
                                    />
                                    <label data-testid="pending-order" htmlFor="mn3" className="consumbales pl-3 text-sm font-normal text-[#090406] text-left cursor-pointer">Pending Confirmation</label>
                                </div>
                                <div
                                    className="relative flex items-center mt-[14px]"
                                    onClick={() => HandleFilter('order_status', '3')}

                                >
                                    <Checkbox
                                        icon={
                                            <Icon.FiCheck color="#FFFF" size={14} style={{ background: `${Filter.order_status?.includes('3') ? '#555259' : ''}` }} />
                                        }
                                        name="my-input"
                                        className="cursor-pointer"
                                        checked={Filter.order_status.includes('3')}
                                        borderColor={`${Filter.order_status.includes('3') ? '#B8C5DC' : '#555259'}`}
                                        style={{ cursor: 'pointer' }}
                                        labelStyle={{ marginLeft: 5, userSelect: 'none', cursor: 'pointer' }}
                                    />
                                    <label htmlFor="mn4" data-testid="approved-order" className="consumbales pl-3 text-sm font-normal text-[#090406] text-left cursor-pointer">Approved</label>
                                </div>
                                <div
                                    className="relative flex items-center mt-[14px]"
                                    onClick={() => HandleFilter('order_status', '8')}

                                >
                                    <Checkbox
                                        icon={
                                            <Icon.FiCheck color="#FFFF" size={14} style={{ background: `${Filter.order_status?.includes('8') ? '#555259' : ''}` }} />
                                        }
                                        name="my-input"
                                        className="cursor-pointer"
                                        checked={Filter.order_status.includes('8')}
                                        borderColor={`${Filter.order_status.includes('8') ? '#B8C5DC' : '#555259'}`}
                                        style={{ cursor: 'pointer' }}
                                        labelStyle={{ marginLeft: 5, userSelect: 'none', cursor: 'pointer' }}
                                    />
                                    <label htmlFor="mn5" data-testid="rejected-order" className="consumbales pl-3 text-sm font-normal text-[#090406] text-left cursor-pointer">Rejected</label>
                                </div>
                                <div
                                    className="relative flex items-center mt-[14px]"
                                    onClick={() => HandleFilter('order_status', '2')}
                                >
                                    <Checkbox
                                        icon={
                                            <Icon.FiCheck color="#FFFF" size={14} style={{ background: `${Filter.order_status?.includes('2') ? '#555259' : ''}` }} />
                                        }
                                        name="my-input"
                                        className="cursor-pointer"
                                        checked={Filter.order_status.includes('2')}
                                        borderColor={`${Filter.order_status.includes('2') ? '#B8C5DC' : '#555259'}`}
                                        style={{ cursor: 'pointer' }}
                                        labelStyle={{ marginLeft: 5, userSelect: 'none', cursor: 'pointer' }}
                                    />
                                    <label htmlFor="mn6" data-testid="process-order" className="consumbales pl-3 text-sm font-normal text-[#090406] text-left cursor-pointer">In-process</label>
                                </div>
                                <div
                                    className="relative flex items-center mt-[14px]"
                                    onClick={() => HandleFilter('order_status', '4')}
                                >
                                    <Checkbox
                                        icon={
                                            <Icon.FiCheck color="#FFFF" size={14} style={{ background: `${Filter.order_status?.includes('4') ? '#555259' : ''}` }} />
                                        }
                                        name="my-input"
                                        className="cursor-pointer"
                                        checked={Filter.order_status.includes('4')}
                                        borderColor={`${Filter.order_status.includes('4') ? '#B8C5DC' : '#555259'}`}
                                        style={{ cursor: 'pointer' }}
                                        labelStyle={{ marginLeft: 5, userSelect: 'none', cursor: 'pointer' }}
                                    />
                                    <label htmlFor="mn7" className="consumbales pl-3 text-sm font-normal text-[#090406] text-left cursor-pointer">Out for Delivery</label>
                                </div>
                                <div
                                    className="relative flex items-center mt-[14px]"
                                    onClick={() => HandleFilter('order_status', '5')}
                                >
                                    <Checkbox
                                        icon={
                                            <Icon.FiCheck color="#FFFF" size={14} style={{ background: `${Filter.order_status?.includes('5') ? '#555259' : ''}` }} />
                                        }
                                        name="my-input"
                                        className="cursor-pointer"
                                        checked={Filter.order_status.includes('5')}
                                        borderColor={`${Filter.order_status.includes('5') ? '#B8C5DC' : '#555259'}`}
                                        style={{ cursor: 'pointer' }}
                                        labelStyle={{ marginLeft: 5, userSelect: 'none', cursor: 'pointer' }}
                                    />
                                    <label htmlFor="mn8" data-testid="partial-order" className="consumbales pl-3 text-sm font-normal text-[#090406] text-left cursor-pointer">Partially delivered</label>
                                </div>
                                <div
                                    className="relative flex items-center mt-[14px]"
                                    onChange={() => HandleFilter('order_status', '6')}

                                >
                                    <Checkbox
                                        icon={
                                            <Icon.FiCheck color="#FFFF" size={14} style={{ background: `${Filter.order_status?.includes('6') ? '#555259' : ''}` }} />
                                        }
                                        name="my-input"
                                        className="cursor-pointer"
                                        checked={Filter.order_status.includes('6')}
                                        borderColor={`${Filter.order_status.includes('6') ? '#B8C5DC' : '#555259'}`}
                                        style={{ cursor: 'pointer' }}
                                        labelStyle={{ marginLeft: 5, userSelect: 'none', cursor: 'pointer' }}
                                    />
                                    <label htmlFor="mn9" className="consumbales pl-3 text-sm font-normal text-[#090406] text-left cursor-pointer">Delivered</label>
                                </div>
                                <div
                                    className="relative flex items-center mt-[14px]"
                                    onClick={() => HandleFilter('order_status', '7')}
                                >
                                    <Checkbox
                                        icon={
                                            <Icon.FiCheck color="#FFFF" size={14} style={{ background: `${Filter.order_status?.includes('7') ? '#555259' : ''}` }} />
                                        }
                                        name="my-input"
                                        className="cursor-pointer"
                                        checked={Filter.order_status.includes('7')}
                                        borderColor={`${Filter.order_status.includes('7') ? '#B8C5DC' : '#555259'}`}
                                        style={{ cursor: 'pointer' }}
                                        labelStyle={{ marginLeft: 5, userSelect: 'none', cursor: 'pointer' }}
                                    />
                                    <label htmlFor="mn10" className="consumbales pl-3 text-sm font-normal text-[#090406] text-left cursor-pointer">Completed</label>
                                </div>
                            </div>
                        </div>
                        <div className={`tab-pane fade${selectedType === 'type' ? 'show active' : ''} px-3`} id="pillcategorie" role="tabpanel" aria-labelledby="pills-categories">
                            <div className="cursor-pointer">
                                {industry && industry.map((ind, indIdx) => (
                                    ind.LOOKUP_CODE !== 'ALL' && (
                                        <div
                                            className="relative flex items-center mt-[14px]"
                                            onClick={() => HandleFilter('type', ind.LOOKUP_CODE)}
                                        >
                                            <Checkbox
                                                icon={
                                                    <Icon.FiCheck color="#FFFF" size={14} style={{ background: `${Filter.type?.includes(ind.LOOKUP_CODE) ? '#555259' : ''}` }} />
                                                }
                                                name="my-input"
                                                className="cursor-pointer"
                                                checked={Filter.type.includes(ind.LOOKUP_CODE)}
                                                borderColor={`${Filter.type.includes(ind.LOOKUP_CODE) ? '#B8C5DC' : '#555259'}`}
                                                style={{ cursor: 'pointer' }}
                                                labelStyle={{ marginLeft: 5, userSelect: 'none', cursor: 'pointer' }}
                                            />
                                            <label htmlFor="mn11" data-testid={`${ind.LOOKUP_CODE.toLowerCase()}-order`} className="consumbales pl-3 text-sm font-normal text-[#090406] text-left cursor-pointer">{ind.LOOKUP_CODE}</label>
                                        </div>
                                    )
                                ))}
                            </div>
                        </div>
                        <div className={`tab-pane fade ${selectedType === 'order_category' ? 'show active' : ''} px-3`} id="pilltype" role="tabpanel" aria-labelledby="pills-type">
                            <div className="cursor-pointer">
                                <div
                                    className="relative flex items-center"
                                    onClick={() => HandleFilter('order_category', 'CONSUMABLES')}
                                >
                                    <Checkbox
                                        icon={
                                            <Icon.FiCheck color="#FFFF" size={14} style={{ background: `${Filter.order_category?.includes('CONSUMABLES') ? '#555259' : ''}` }} />
                                        }
                                        name="my-input"
                                        className="cursor-pointer"
                                        checked={Filter.order_category.includes('CONSUMABLES')}
                                        borderColor={`${Filter.order_category.includes('CONSUMABLES') ? '#B8C5DC' : '#555259'}`}
                                        style={{ cursor: 'pointer' }}
                                        labelStyle={{ marginLeft: 5, userSelect: 'none', cursor: 'pointer' }}
                                    />
                                    <label htmlFor="xs2" data-testid="consumable-order" className="consumbales pl-3 text-sm font-normal text-[#090406] text-left cursor-pointer">Consumables</label>
                                </div>
                                <div
                                    className="relative flex items-center mt-[14px] mb-3"
                                    onClick={() => HandleFilter('order_category', 'EQUIPMENTS/SGP')}
                                >
                                    <Checkbox
                                        icon={
                                            <Icon.FiCheck color="#FFFF" size={14} style={{ background: `${Filter.order_category?.includes('EQUIPMENTS/SGP') ? '#555259' : ''}` }} />
                                        }
                                        name="my-input"
                                        className="cursor-pointer"
                                        checked={Filter.order_category.includes('EQUIPMENTS/SGP')}
                                        borderColor={`${Filter.order_category.includes('EQUIPMENTS/SGP') ? '#B8C5DC' : '#555259'}`}
                                        style={{ cursor: 'pointer' }}
                                        labelStyle={{ marginLeft: 5, userSelect: 'none', cursor: 'pointer' }}
                                    />
                                    <label htmlFor="xs3" data-testid="equipment-order" className="consumbales pl-3 text-sm font-normal text-[#090406] text-left cursor-pointer">Equipment/Spares</label>
                                </div>
                                <div
                                    className="relative flex items-center mt-[14px] mb-3"
                                    onClick={() => HandleFilter('order_category', 'MnR')}
                                >
                                    <Checkbox
                                        icon={
                                            <Icon.FiCheck color="#FFFF" size={14} style={{ background: `${Filter.order_category?.includes('MnR') ? '#555259' : ''}` }} />
                                        }
                                        name="my-input"
                                        className="cursor-pointer"
                                        checked={Filter.order_category.includes('MnR')}
                                        borderColor={`${Filter.order_category.includes('MnR') ? '#B8C5DC' : '#555259'}`}
                                        style={{ cursor: 'pointer' }}
                                        labelStyle={{ marginLeft: 5, userSelect: 'none', cursor: 'pointer' }}
                                    />
                                    <label htmlFor="xs3" data-testid="equipment-order" className="consumbales pl-3 text-sm font-normal text-[#090406] text-left cursor-pointer">MnR</label>
                                </div>
                                <div
                                    className="relative flex items-center"
                                    onClick={() => HandleFilter('order_category', 'TRADING')}
                                >
                                    <Checkbox
                                        icon={
                                            <Icon.FiCheck color="#FFFF" size={14} style={{ background: `${Filter.order_category?.includes('TRADING') ? '#555259' : ''}` }} />
                                        }
                                        name="my-input"
                                        className="cursor-pointer"
                                        checked={Filter.order_category.includes('TRADING')}
                                        borderColor={`${Filter.order_category.includes('TRADING') ? '#B8C5DC' : '#555259'}`}
                                        style={{ cursor: 'pointer' }}
                                        labelStyle={{ marginLeft: 5, userSelect: 'none', cursor: 'pointer' }}
                                    />
                                    <label htmlFor="xs4" data-testid="trading-order" className="consumbales pl-3 text-sm font-normal text-[#090406] text-left cursor-pointer">Trading</label>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="flex w-full">
                    <div className="pt-3 flex justify-end w-[30%] mr-5">
                        <button
                            onClick={() => handleClear()}
                            type="button"
                            className="w-full sm:h-10 h-9 border-2 border-[#555259]  bg-[#FFFFFF] rounded-lg text-sm font-semibold filter1 text-[#555259]"
                            data-bs-dismiss="modal"
                            aria-label="Close"
                        >
                            Clear Filter
                        </button>
                    </div>
                    <div className="pt-3 flex justify-end w-[70%]">
                        <button
                            onClick={() => generateUrl()}
                            type="button"
                            className="w-full sm:h-10 h-9 border border-[#555259] bg-[#555259] rounded-lg text-sm font-semibold apply text-[#FFFFFF]"
                            data-bs-dismiss="modal"
                            aria-label="Close"
                            data-testid="apply-btn"
                        >
                            Apply Filter
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default FilterModal;
